import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { Details } from "../../services/staff.services";

const StaffView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Staff"),
      url: "/admin/staff/list/1",
    },
    { title: t("admin.cafes.link_view"), url: "" },
  ];


  useEffect(() => {
    Details(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                <div className="col-lg-12 form-group">
                  <table id="simple-table" className="table  table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th>{t("Profile Image")}</th>
                        <td>
                          <img
                            src={
                              showdefault && showdefault.profile_image
                                ? showdefault.profile_image
                                : "N/A"
                            }
                            alt="profile"
                            style={{ height: "100px" }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>{t("First Name")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.first_name
                            ? showdefault.first_name
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Last Name")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.last_name
                            ? showdefault.last_name
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("admin.cafes.label_email")}</th>
                        <td>
                          {showdefault && showdefault.email
                            ? showdefault.email
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("admin.cafes.label_phone_number")}</th>
                        <td>
                          {showdefault && showdefault?.phone_number
                            ? showdefault.phone_number
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("admin.list_heading.list_heading_created_date")}</th>
                        <td>
                          {showdefault && showdefault.createdAt
                            ? formateDate(showdefault.createdAt)
                            : "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="mt-5">
                    <button className="btn ripple btn-dark" type='button' onClick={() => navigate(-1)}>
                      <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                      {t("admin.button.btn_back")}
                    </button>
                  </div>
                </div>
              </div> : <Loader />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffView;
